<template>
  <v-chip
    v-if="status && status != ''"
    class="application-status-chip"
    v-bind="getStatusChipProperties(status)"
  >
    <span class="application-status-chip-text">
      {{ getStatusText(status) }}
    </span>
  </v-chip>
</template>

<script>
import {EA_STATUS}  from '@/constants'

export default {
  name: 'StatusChip',
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  methods: {
    getStatusText(status){
      return EA_STATUS[status]
    },
    getStatusChipProperties(status) {
      if (status === EA_STATUS.NEW) {
        return {
          outlined: true,
          //color: 'primary lighten-1' // blue-1
        }
      }

      if (status === EA_STATUS.REQ_APPROVED) {
        return {
          color: 'success',
          'text-color': 'white'
        }
      }

      if (status === EA_STATUS.APPROVAL_REQ_DENIED) {
        return {
          color: 'red base', // dark-60
          'text-color': 'white'
        }
      }

      return {
        // color: 'primary lighten-1', // blue-1
        'text-color': 'white'
      }
    }
  }
}
</script>

<style scoped>
.application-status-chip {
  display: block;
  text-align: center;
  height: 23px;
  padding-top: 1px;
  background-color: var(--v-primary-base) !important;
  border-color: var(--v-primary-base) !important;
}
.application-status-chip-text {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.875rem;
}
</style>
